module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("©2023 William R. Cobb, Editor")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("First Edition, First Printing")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Library of Congress Control Number: 2022949790")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("ISBN-13: 978-1-61121-514-4")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("eISBN: 978-1-94066-996-0")]), _vm._v(" "), _c('div', {
    staticClass: "img_containerc"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/copy.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Savas Beatie")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("989 Governor Drive, Suite 102")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("El Dorado Hills, CA 95762")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Phone: 916-941-6896 / "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:sales@savasbeatie.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("sales@savasbeatie.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Savas Beatie titles are available at special discounts for bulk purchases in the United States. Contact us for more details.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa865f28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 60
// module chunks = 0